module.exports = __webpack_public_path__ + "img/tit3.9eb2958b.png";